export const TEMPLATE_ACTIONS = {
  EDIT_TEMPLATE: 'edit_template',
  EDIT_CELLS: 'edit_cells',
  DOWNLOAD_TEMPLATE: 'download_template',
  REPLACE_TEMPLATE: 'replace_template',
};

export const TEMPLATE_ACTION_OPTIONS = [
  {
    id: TEMPLATE_ACTIONS.EDIT_TEMPLATE,
    label: 'Edit Template',
  },
  {
    id: TEMPLATE_ACTIONS.EDIT_CELLS,
    label: 'Edit Cells',
  },
  {
    id: TEMPLATE_ACTIONS.DOWNLOAD_TEMPLATE,
    label: 'Download Template',
  },
  {
    id: TEMPLATE_ACTIONS.REPLACE_TEMPLATE,
    label: 'Replace Template',
  },
];
